import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefTraining from "table-defs/TableDefTraining";
import AddTrainingModal from "./components/AddTrainingModal/AddTrainingModal";
import EditTrainingModal from "./components/EditTrainingModal/EditTrainingModal";
import useFilterRows from "helpers/customHooks/useFilterRows";
import TrainingBulkUploadModal from "./components/TrainingBulkUploadModal/TrainingBulkUploadModal";
import styles from "./Training.module.scss";
import ReactDOM from "react-dom";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";

import {
    loadSitesAction,
    loadTrainingCoursesAction,
    loadTrainingAction,
    deleteTrainingAction,
    completeTrainingAction,
    incompleteTrainingAction,
    updateTrainingAction,
    loadRolesAction,
} from "store/actions/Actions";

import { setSelectedRows, toggleDropdowns } from "helpers/utils";

const Training = props => {
    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: []
    });

    const {
        loadSitesAction,
        loadTrainingCoursesAction,
        loadTrainingAction,
        SitesReducer,
        TrainingReducer,
        RolesReducer,
        loadRolesAction,
    } = props;

    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);
    
    useEffect(() => {
        if (!TrainingReducer.training && SitesReducer.sites && RolesReducer.roles) {
            loadTrainingAction();
        }
    }, [TrainingReducer.training, SitesReducer.sites, loadTrainingAction, RolesReducer.roles]);

    useEffect(() => {
        if (!RolesReducer.roles) {
          loadRolesAction();
        }
    }, [RolesReducer.roles, loadRolesAction]);

    useEffect(() => {
        if (!TrainingReducer.training_courses && SitesReducer.sites) {
            loadTrainingCoursesAction();
        }
    }, [TrainingReducer.training_courses, SitesReducer.sites, loadTrainingCoursesAction]);

    let roleList = {};
    if (RolesReducer && RolesReducer.roles) {
        RolesReducer.roles.map((role) => {
            if (role.name && !role.name.includes('Super')) {
                roleList[role.id] = { id: role.id, name: role.name };
            }
            return false;
        });
    }

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        selected_sites: [],
        dateField: "assigned",
    };

    const [filters, setFilters] = useState(noFilters);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const filteredRows = useFilterRows(filters, TrainingReducer.training);

    const [selectedTrainngIds, setSelectedTrainngIds] = useState([]);

    const actDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();

    const handleNotify = (selectedTrainingIds) => {
        // props.notifyTrainingAction({"items" : selectedTrainingIds.map(item => item.id) });
    }

    const handleComplete = (selectedTrainingIds) => {
        props.completeTrainingAction({"items" : selectedTrainingIds.map(item => item.id) });
    };

    const handleIncomplete = (selectedTrainingIds) => {
        props.incompleteTrainingAction({"items" :  selectedTrainingIds.map(item => item.id)});
    };

    const handleDelete = (selectedTrainingIds) => {
        props.deleteTrainingAction({"items" :  selectedTrainingIds.map(item => item.id)});
    };

    const getSitesList = () => {
        try {
            const sitesList = SitesReducer.sites ? SitesReducer.sites.map(site => {
                return {
                    id: site.id,
                    siteName: site.name,
                    value: filters.selected_sites.includes(site.id) ? true : false
                }
            }) : [];
            sitesList.unshift({id: null, siteName: 'All Sites', value: filters.selected_sites.includes("") });
            return sitesList;
        } catch (error) {
            console.log('error with site list', error);
        }
        return [];
    };

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                chooseActionDropdownRef,
                siteDropdownRef,
                actDropdownRef,
                statusDropdownRef
            ])}
        >
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    className={styles['page-header-actions-training']}
                    classNameSearch={styles['search']}
                    classNameRight={styles['page-header-right']}
                    primaryButtonText="ADD TRAINING"
                    primaryButtonHandler={() => setShowModal(!showModal)}
                    secondaryButtonText="UPLOAD TRAINING"
                    secondaryButtonHandler={() =>
                        setShowBulkUploadModal(!showBulkUploadModal)
                    }
                    searchHandler={e => setFilters({ ...filters, text: e.target.value || "" })}
                    searchValue={filters.text}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={[
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => handleNotify(selectedTrainngIds)
                        },
                        {
                            actionName: "Mark Selected Complete",
                            actionHandler: () => handleComplete(selectedTrainngIds)
                        },
                        {
                            actionName: "Mark Selected Incomplete",
                            actionHandler: () => handleIncomplete(selectedTrainngIds)
                        },
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => {
                                
                                const idCount = selectedTrainngIds.length;

                                if (idCount > 0) {
                                    setShowConfirmModal({
                                        title: 'Delete selected trainings',
                                        question: idCount === 1 ? 
                                            `Are you sure you want to delete the selected training?` : 
                                            `Are you sure you want to delete ${idCount} selected trainings?`,
                                        confirmAction: () => {
                                            handleDelete(selectedTrainngIds);
                                        },
                                    });
                                } else {
                                    setShowConfirmModal({
                                        type: 'simple',
                                        title: 'Nothing selected',
                                        question: `Please select trainings to be deleted.`,
                                    });
                                }
                            }
                        }
                    ]}
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: getSitesList(),
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "Complete", "Incomplete"]
                    }}
                    statusDropdownRef={statusDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {showBulkUploadModal &&
                    <TrainingBulkUploadModal setShowModal={setShowBulkUploadModal} />
                }
                {TrainingReducer.training &&
                <FullDataTable
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains("col-row-selector")
                        ) {
                            return;
                        }
                        setShowEditModal(this.props.rowData.id);
                        // props.history.push(`/achieve/training/edit?id=${this.props.rowData.id}`);

                    }}
                    rowsData={filteredRows}
                    definitions={TableDefTraining}
                    onChangeRowSelect={({ selectedRows }) =>
                        onChangeRowSelect({ selectedRows })
                    }
                    customTableProps={{
                        selectedRows: state.selectedRows,
                        handleNotify: item => handleNotify([{ id: item.id }]),
                        handleComplete: item => handleComplete([{ id: item.id }]),
                        handleIncomplete: item => handleIncomplete([{ id: item.id }]),
                        handleDelete: ({ id, folder_name }) => {
                            setShowConfirmModal({
                                title: 'Delete the training',
                                question: `Are you sure you want to remove the training "${folder_name}"`,
                                confirmAction: () => {
                                    handleDelete([{ id }])
                                },
                            });
                        }
                    }}
                    setSelectedRows={setSelectedRows(["id"], setSelectedTrainngIds)}
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>

            {showModal ? (
                <AddTrainingModal
                    training_courses={TrainingReducer.training_courses}
                    setShowModal={setShowModal}
                    // actDropdownRef={actDropdownRef}
                    // siteDropdownRef={siteDropdownRef}
                />
            ) : null}

            {showEditModal ? (
                <EditTrainingModal
                    training_courses={TrainingReducer.training_courses}
                    setShowModal={setShowEditModal}
                    training_id={showEditModal}
                    // actDropdownRef={actDropdownRef}
                    // siteDropdownRef={siteDropdownRef}
                />
            ) : null}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    TrainingReducer: state.TrainingReducer,
    SitesReducer: state.SitesReducer,
    RolesReducer: state.RolesReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadTrainingCoursesAction,
    loadTrainingAction,
    deleteTrainingAction,
    completeTrainingAction,
    incompleteTrainingAction,
    updateTrainingAction,
    loadRolesAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Training);
